import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { QuillModule } from 'ngx-quill';
import { ApiService } from '../../../core/services/api.service';
declare var bootstrap: any;
@Component({
  selector: 'app-questionary',
  imports: [FormsModule, CommonModule, QuillModule],
  standalone: true,
  templateUrl: './questionary.html',
  styleUrl: './questionary.scss',
})
export class Questionary {
  loading:any;
  editorContent = '';
  selectedQuestion: any = {};
  isEditMode = false;
  constructor(private http: HttpClient, private api: ApiService) {}
  logedInUser: any;
  userId: any;
  ngOnInit(): void {
    const userStr = localStorage.getItem('userInfo');
    this.logedInUser = userStr ? JSON.parse(userStr) : null;
    const userId = localStorage.getItem('fcmToken');
    this.userId = userId ? JSON.parse(userId) : null;
    this.getCategories();
    this.Questions();
  }
  Questions() {
    this.loading=true;
    this.api.getMethod('/questions').subscribe((res: any) => {
      this.submittedQuestions = res;
      this.loading=false;

    });

  }
  submittedQuestions: any = [];
  openEditModal(q: any) {
    this.isEditMode = true;
    this.selectedQuestion = { ...q };
    const modal = new bootstrap.Modal(document.getElementById('editModal'));
    modal.show();
  }

  openAddModal() {
    this.isEditMode = false;
    this.selectedQuestion = {
      Id: 0,
      QuestionText: '',
      Query: '',
      CategoryId: null,
    };
    const modal = new bootstrap.Modal(document.getElementById('editModal'));
    modal.show();
  }

  getCategories() {
    this.api.getMethod('/categories').subscribe((data: any) => {
      this.categories = data; 
    });
  }

  getCategoryName(categoryId: number): string {
    const category = this.categories.find((c) => c.TWL_ID === categoryId);
    return category ? category.TWL_NAME : 'Uncategorized';
  }

  categories: any[] = [];
  saveChanges() {
    this.loading=true;

    const body = {
      questionText: this.selectedQuestion.QuestionText,
      query: this.selectedQuestion.Query,
      categoryId: Number(this.selectedQuestion.CategoryId),
      createdBy: this.logedInUser?.user_Info.roleid.toString(),
      answer: this.selectedQuestion.Answer,
    };

    if (this.isEditMode) {
      this.api.putmethod(`/questions/${this.selectedQuestion.Id}`, body).subscribe((res: any) => {
          const index = this.submittedQuestions.findIndex(
            (item: any) => item.Id === this.selectedQuestion.Id
          );
          if (index !== -1) {
            this.submittedQuestions[index] = { ...this.selectedQuestion };
          }
        });
      this.Questions();

    }
   else {
      this.api.postmethod(`questions`, body).subscribe((res: any) => {
        this.Questions();

      });
    }

    const modal = bootstrap.Modal.getInstance(
      document.getElementById('editModal')
    );
    modal.hide();
  }
  resetForm() {
    this.selectedQuestion = {
      Id: 0,
      QuestionText: '',
      Query: '',
      CategoryId: null,
      Answer: '',
    };
  }
}
